import * as Sentry from '@sentry/react';
import { toast } from 'sonner';

// Test component to verify Sentry's error tracking is working
export function SentryTestButton() {
  const handleClick = () => {
    try {
      throw new Error('This is your first error!');
    } catch (error) {
      Sentry.captureException(error);
      toast.success('Test error sent to Sentry!', {
        description: 'Check your Sentry dashboard to see the captured error.',
      });
    }
  };

  return (
    <button
      onClick={handleClick}
      className="px-4 py-2 bg-destructive text-destructive-foreground rounded-md hover:bg-destructive/90 transition-colors"
    >
      Break the world
    </button>
  );
}
